(function () {
  'use strict';

  const STORAGE_KEY = 'selectedState';

  function normalizeState(value) {
    return String(value || '').trim().toLowerCase().replace(/\./g, '').replace(/\s+/g, '');
  }

  function getShopifyRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function getProductStateTags(tags) {
    if (!Array.isArray(tags)) return [];

    return tags.map(function (tag) {
      return String(tag || '').trim().toLowerCase();
    }).filter(function (tag) {
      return tag.indexOf('state_') === 0;
    }).map(function (tag) {
      return normalizeState(tag.replace('state_', ''));
    }).filter(Boolean);
  }

  function updateDesktopGridColumns() {
    const grids = document.querySelectorAll('slider-component .product-grid');

    grids.forEach(function (grid) {
      const products = grid.querySelectorAll(':scope > li[data-product-tags]');
      const count = products.length;
      const sliderComponent = grid.closest('slider-component');

      if (!sliderComponent) return;

      let noResultsMessage = sliderComponent.querySelector('.state-no-results-message');

      if (count === 0) {
        if (!noResultsMessage) {
          noResultsMessage = document.createElement('div');
          noResultsMessage.className = 'state-no-results-message';
          noResultsMessage.innerHTML = '<p>No results found for this location.</p>';
          sliderComponent.appendChild(noResultsMessage);
        }

        noResultsMessage.style.display = 'block';
        return;
      }

      if (noResultsMessage) noResultsMessage.style.display = 'none';

      const columnCount = Math.min(count, 6);

      grid.classList.remove(
        'grid--1-col-desktop',
        'grid--2-col-desktop',
        'grid--3-col-desktop',
        'grid--4-col-desktop',
        'grid--5-col-desktop',
        'grid--6-col-desktop'
      );

      grid.classList.add('grid--' + columnCount + '-col-desktop');

      console.log('[STATE GRID] Products:', count, 'Desktop columns:', columnCount);
    });
  }

  function setSelectValue(select, state) {
    if (!select || !state) return;

    const normalizedState = normalizeState(state);

    const matchingOption = Array.from(select.options).find(function (option) {
      return normalizeState(option.value) === normalizedState;
    });

    if (!matchingOption) {
      console.warn('[STATE] Matching option not found:', normalizedState, select.id);
      return;
    }

    Array.from(select.options).forEach(function (option) {
      option.selected = false;
    });

    matchingOption.selected = true;
    select.value = matchingOption.value;

    console.log('[STATE] Synced selector:', select.id, 'Value:', select.value);
  }

  function syncStateSelectors(state) {
    const normalizedState = normalizeState(state);

    if (!normalizedState) return;

    const modalStateSelect = document.getElementById('modalDropdownState');
    const announcementStateSelect = document.getElementById('announcementStateSelector');

    setSelectValue(modalStateSelect, normalizedState);
    setSelectValue(announcementStateSelect, normalizedState);
  }

  async function getProductByHandle(handle) {
    if (!handle) return null;

    try {
      const response = await fetch(getShopifyRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) throw new Error('Product request failed: ' + response.status);

      return await response.json();
    } catch (error) {
      console.error('[STATE CART] Product fetch failed:', handle, error);
      return null;
    }
  }

  async function removeCartLine(lineKey) {
    try {
      const response = await fetch(getShopifyRoot() + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0
        })
      });

      if (!response.ok) throw new Error('Cart remove failed: ' + response.status);

      await response.json();

      console.log('[STATE CART] Removed line:', lineKey);

      return true;
    } catch (error) {
      console.error('[STATE CART] Remove failed:', lineKey, error);
      return false;
    }
  }

  window.removeUnavailableCartProducts = async function (selectedState) {
    selectedState = normalizeState(selectedState);

    if (!selectedState) return;

    console.log('[STATE CART] Checking cart for state:', selectedState);

    try {
      const response = await fetch(getShopifyRoot() + 'cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) throw new Error('Cart request failed: ' + response.status);

      const cart = await response.json();

      if (!cart.items || !cart.items.length) {
        console.log('[STATE CART] Cart is empty.');
        return;
      }

      const productCache = new Map();
      const linesToRemove = [];

      for (const item of cart.items) {
        const handle = item.handle;

        if (!handle) continue;

        let productData = productCache.get(handle);

        if (!productData) {
          productData = await getProductByHandle(handle);

          if (productData) {
            productCache.set(handle, productData);
          }
        }

        if (!productData) continue;

        const productStates = getProductStateTags(productData.tags);

        console.log(
          '[STATE CART]',
          item.product_title,
          'States:',
          productStates,
          'Selected:',
          selectedState
        );

        if (productStates.length === 0) continue;
        if (productStates.includes(selectedState)) continue;

        linesToRemove.push(item.key);
      }

      if (!linesToRemove.length) {
        console.log('[STATE CART] All cart products are available.');
        return;
      }

      for (const lineKey of linesToRemove) {
        await removeCartLine(lineKey);
      }

      console.log('[STATE CART] Unavailable products removed.');
    } catch (error) {
      console.error('[STATE CART] Cart check failed:', error);
    }
  };

  window.filterProductsBySelectedState = function () {
    const selectedState = normalizeState(localStorage.getItem(STORAGE_KEY));

    console.log('[STATE] Selected state:', selectedState);

    if (!selectedState) {
      console.log('[STATE] No state selected yet.');
      updateDesktopGridColumns();
      return;
    }

    const productItems = document.querySelectorAll('[data-product-tags]');

    console.log('[STATE] Products found:', productItems.length);

    productItems.forEach(function (item) {
      const rawTags = item.getAttribute('data-product-tags') || '';

      const productStates = rawTags.split(',').map(function (state) {
        return normalizeState(state);
      }).filter(Boolean);

      console.log('[STATE] Product:', item.id, 'States:', productStates);

      if (productStates.length === 0) return;
      if (productStates.includes(selectedState)) return;

      console.log('[STATE] Removing product:', item.id);

      item.remove();
    });

    updateDesktopGridColumns();
  };

  window.checkMainProductState = function () {    
    const selectedState = normalizeState(localStorage.getItem(STORAGE_KEY));
    const productInfo = document.querySelector('.state-wise-product');
    const stateField = document.querySelector('.main_state-p[main-product-tag]');
    console.log('111111');
    if (!productInfo) return;

    if (!selectedState || !stateField) {
      productInfo.classList.add('state-check-done');
      return;
    }

    const rawTags = stateField.getAttribute('main-product-tag') || '';

    const productStates = rawTags.split(',').map(function (state) {
      return normalizeState(state);
    }).filter(Boolean);

    console.log('[MAIN PRODUCT] Selected state:', selectedState);
    console.log('[MAIN PRODUCT] Product states:', productStates);

    const mainSection = productInfo.closest('.shopify-section');

    if (!mainSection) {
      productInfo.classList.add('state-check-done');
      return;
    }

    let message = mainSection.querySelector('.state-product-unavailable-message');
    console.log('message', message);
    if (!message) {
      message = document.createElement('div');
      message.className = 'state-product-unavailable-message page-width';
      message.innerHTML = '<h2>Sorry, we are unable to supply this product to your location. We are always working on new delivery areas.</h2>';
      mainSection.appendChild(message);
    }
    console.log('productStates', productStates);
    console.log('selectedState', selectedState);
    if (productStates.length === 0 || productStates.includes(selectedState)) {
      productInfo.style.display = '';
      productInfo.classList.add('state-check-done');
      message.classList.remove('is-visible');
      return;
    }

    productInfo.style.display = 'none';
    message.classList.add('is-visible');
  };

  function initProductStateFilter() {
    const selectedState = normalizeState(localStorage.getItem(STORAGE_KEY));

    syncStateSelectors(selectedState);
    window.filterProductsBySelectedState();
    window.checkMainProductState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductStateFilter);
  } else {
    initProductStateFilter();
  }

  document.addEventListener('DOMContentLoaded', function () {
    const stateSelect = document.getElementById('modalDropdownState');
    const modal = document.getElementById('selectStateModal');
    const announcementStateSelect = document.getElementById('announcementStateSelector');

    const savedState = normalizeState(localStorage.getItem(STORAGE_KEY));

    syncStateSelectors(savedState);

    if (announcementStateSelect) {
      announcementStateSelect.addEventListener('change', async function () {
        const selectedState = normalizeState(this.value);

        if (!selectedState) return;

        announcementStateSelect.disabled = true;

        localStorage.setItem(STORAGE_KEY, selectedState);
        syncStateSelectors(selectedState);

        console.log('[STATE] Changed from announcement:', selectedState);

        await window.removeUnavailableCartProducts(selectedState);

        window.location.reload();
      });
    }

    if (!stateSelect || !modal) return;

    function openStateModal() {
      const currentState = normalizeState(localStorage.getItem(STORAGE_KEY));

      if (currentState) {
        syncStateSelectors(currentState);
      }

      modal.classList.remove('is-closing');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
    }

    function closeStateModal() {
      modal.classList.add('is-closing');
      modal.setAttribute('aria-hidden', 'true');

      setTimeout(function () {
        modal.classList.remove('is-open', 'is-closing');
        document.body.classList.remove('selectStateModal-open');
      }, 300);
    }

    if (savedState) {
      syncStateSelectors(savedState);

      modal.classList.remove('is-open', 'is-closing');
      document.body.classList.remove('selectStateModal-open');
      modal.setAttribute('aria-hidden', 'true');

      window.filterProductsBySelectedState();
      window.checkMainProductState();
    } else {
      requestAnimationFrame(function () {
        openStateModal();
      });
    }

    stateSelect.addEventListener('change', function () {
      const selectedState = normalizeState(this.value);

      if (!selectedState) return;

      localStorage.setItem(STORAGE_KEY, selectedState);
      syncStateSelectors(selectedState);

      console.log('[STATE] Saved:', selectedState);
    });

    const closeButtons = modal.querySelectorAll('[data-state-modal-close]');

    closeButtons.forEach(function (button) {
      button.addEventListener('click', async function (event) {
        event.preventDefault();

        const selectedState = normalizeState(stateSelect.value);

        if (button.classList.contains('selectStateModal__button')) {
          if (!selectedState) {
            stateSelect.focus();
            return;
          }

          button.disabled = true;

          localStorage.setItem(STORAGE_KEY, selectedState);
          syncStateSelectors(selectedState);

          await window.removeUnavailableCartProducts(selectedState);

          window.location.reload();
          return;
        }

        const currentState = normalizeState(localStorage.getItem(STORAGE_KEY));

        if (!currentState) return;

        closeStateModal();
      });
    });

    document.addEventListener('shopify:section:load', function () {
      const currentState = normalizeState(localStorage.getItem(STORAGE_KEY));

      syncStateSelectors(currentState);
      window.filterProductsBySelectedState();
      window.checkMainProductState();
    });
  });
})();